import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51ac30af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-root" }
const _hoisted_2 = { class: "game-head" }
const _hoisted_3 = {
  key: 0,
  class: "pc-head"
}
const _hoisted_4 = { class: "inf" }
const _hoisted_5 = { class: "inf-label" }
const _hoisted_6 = { class: "inf-value" }
const _hoisted_7 = { class: "inf" }
const _hoisted_8 = { class: "inf-label" }
const _hoisted_9 = { class: "inf-value" }
const _hoisted_10 = { class: "inf" }
const _hoisted_11 = { class: "inf-label" }
const _hoisted_12 = { class: "inf-value" }
const _hoisted_13 = { class: "pc-menu" }
const _hoisted_14 = {
  key: 1,
  class: "mobile-head"
}
const _hoisted_15 = { class: "m-inf" }
const _hoisted_16 = { class: "m-label" }
const _hoisted_17 = { class: "m-value" }
const _hoisted_18 = { class: "m-inf" }
const _hoisted_19 = { class: "m-label" }
const _hoisted_20 = { class: "m-value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-fill" }, null, -1))
const _hoisted_22 = { class: "game-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_home = _resolveComponent("icon-home")!
  const _component_icon_menu = _resolveComponent("icon-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_switch_table = _resolveComponent("switch-table")!
  const _component_limit_dialog = _resolveComponent("limit-dialog")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.deviceOrientation === 'landscape')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('common.desk')) + ":", 1),
                _createElementVNode("div", _hoisted_6, "F" + _toDisplayString(_ctx.desk), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('common.account')) + ":", 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.user), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t('common.balance')) + ":", 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.coin), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "menu-item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
              }, _toDisplayString(_ctx.t('menu.loby')), 1),
              _createElementVNode("div", {
                class: "menu-item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialog('bet-history')))
              }, _toDisplayString(_ctx.t('menu.accounthistory')), 1),
              _createElementVNode("div", {
                class: "menu-item",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFullScreen && _ctx.toggleFullScreen(...args)))
              }, _toDisplayString(_ctx.isFull
                                ? _ctx.t('menu.exitfullscreen')
                                : _ctx.t('menu.fullscreen')), 1)
            ])
          ]))
        : (_ctx.deviceOrientation === 'portrait')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t('common.account')) + ":", 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.user), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t('common.balance')) + ":", 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.coin), 1)
              ]),
              _hoisted_21,
              _createElementVNode("div", {
                class: "m-btn-setting home",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/')))
              }, [
                _createVNode(_component_icon_home)
              ]),
              _createElementVNode("div", {
                class: "m-btn-setting",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDialog('setting')))
              }, [
                _createVNode(_component_icon_menu)
              ])
            ]))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_router_view, {
        ref: "refContent",
        desk: _ctx.desk,
        gameType: _ctx.gameType,
        xian: _ctx.xian,
        onShoeJu: _cache[5] || (_cache[5] = (str)=>_ctx.shoeAndJu=str),
        onShowSelectTable: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showSwitchTable = !_ctx.showSwitchTable)),
        onShowDialog: _ctx.showDialog,
        onShowSwitchDesk: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showMobileSwitchDesk = true)),
        onEnterTable: _ctx.handleSwitchTable,
        onShowLimit: _ctx.showLimit
      }, null, 8, ["desk", "gameType", "xian", "onShowDialog", "onEnterTable", "onShowLimit"])
    ]),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withCtx(() => [
        (_ctx.showSwitchTable)
          ? _withDirectives((_openBlock(), _createBlock(_component_switch_table, {
              key: 0,
              class: "switch-table",
              onSessionExpired: _ctx.handleSessionExpired,
              onEnterTable: _ctx.handleSwitchTable,
              onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showSwitchTable = false))
            }, null, 8, ["onSessionExpired", "onEnterTable"])), [
              [_directive_click_outside, _ctx.hideSwitchTable]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withCtx(() => [
        (_ctx.showLimitInfo)
          ? (_openBlock(), _createBlock(_component_limit_dialog, {
              key: 0,
              "game-type": _ctx.gType,
              onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showLimitInfo = false))
            }, null, 8, ["game-type"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}